import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal } from '../modules/active_modal';
import { requestPasswordReset } from '../modules/high_level_actions';


class ModalForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.requestReset = this.requestReset.bind(this);
  }

  requestReset(evt) {
    evt.preventDefault();
    //using browser input validation
    this.props.dispatch( requestPasswordReset(evt.target.firstChild.value) );
  }

  render() {
    let {dispatch} = this.props;
    return (
      <div className="modal-window login">
        <div className="modal-close" onClick={() => dispatch( closeModal() )}>&times;</div>
        <h2>Retrieve Password</h2>
        <p>
          Please enter your email address below.
          You will receive a link to reset your password.
        </p>
        <form name="forgotPassword" onSubmit={this.requestReset}>
          <input
            type        = "text"
            name        = "email"
            placeholder = "Enter your email address"
            required
          />
          <button className="btn-primary full-width">Send Request</button>
        </form>
      </div>
    )
  }
};


export default connect()(ModalForgotPassword);


// WEBPACK FOOTER //
// ./src/components/ModalForgotPassword.jsx